export default {"src":"/_next/static/media/empty.36461f77.svg","height":65,"width":52,"blurWidth":0,"blurHeight":0};